var React = require('react');

function BoldArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 7a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.36.232a1 1 0 0 0-.128 1.408L13.698 7l-4.466 5.36a1 1 0 0 0 1.536 1.28l5-6a1 1 0 0 0 0-1.28l-5-6A1 1 0 0 0 9.36.232Z","key":1})]);
}

BoldArrowRight.defaultProps = {"viewBox":"0 0 16 14","fill":"#F6662B"};

module.exports = BoldArrowRight;

BoldArrowRight.default = BoldArrowRight;
